import React from 'react';
import { AvatarImg } from './AvatarStyled';
import blank from '../../images/avatarTabela.svg';
/* Komponent awatara użytkownika */
export var Avatar = function (_a) {
    var avatar = _a.avatar;
    return (React.createElement(AvatarImg, { src: avatar ? avatar : blank, alt: "avatar" }));
};
